import { render, staticRenderFns } from "./EmployeeFront.vue?vue&type=template&id=50b96cf7"
import script from "./EmployeeFront.vue?vue&type=script&lang=js"
export * from "./EmployeeFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports